import React, { useEffect, useContext, useState } from 'react'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Auth from '../../../data/auth-service';
import Permissions from '../../../data/permissions';
import DataContext from '../../../data/data-context';
import DisplayCard from '../../../components/displaycard';



const portmirroring = [
    {
        title: 'AWS',
        description: 'Configure AWS traffic mirroring',
        img: '/images/aws.png',
        route: '/system/port_mirroring/aws',
        perm: {
            AWS: [...Permissions.System.Mirroring.AWS],
        },
    },
    {
        title: 'GCP',
        description: 'Configure GCP packet mirroring',
        img: '/images/aws.png',
        route: '/system/port_mirroring/gcp/gcp_credentials',
        perm: {
            GCP: [...Permissions.System.Mirroring.GCP],
        },
    },
];

const Portmirroring = (props) => {

    const { systemSettings } = useContext(DataContext)
    const [updatedPortMirroring, setUpdatedPortMirroring] = useState(portmirroring);

    useEffect(() => {

        const updatedMirroring = portmirroring.map(item => {
            if (systemSettings?.gcp) {
                if (item.title === 'GCP' && systemSettings.gcp?.user_creds.project_id !== "") {
                    return {
                        ...item,
                        route: '/system/port_mirroring/gcp',
                    };
                }

            }
            return item;
        });

        setUpdatedPortMirroring(updatedMirroring);
    }, [systemSettings.gcp]);

    return (
        <Box mb={2}>
            <Grid container spacing={5}>
                {updatedPortMirroring
                    .filter(o => Auth.perm(o.perm))
                    .map((p, i) => (
                        <Grid item xl={3} lg={4} key={`port-mirroring-${i}`}>
                            <DisplayCard {...p} noButton />
                        </Grid>
                    ))}
            </Grid>
        </Box>
    );
};

export default Portmirroring;